package org.braunequip.web.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.css.functions.url
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.navigation.OpenLinkStrategy
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.braunequip.web.components.layouts.PageLayout
import org.braunequip.web.styles.*
import org.braunequip.web.util.Constants
import org.jetbrains.compose.web.attributes.ButtonType
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*
import com.varabyte.kobweb.silk.components.forms.Button as onClickButton

@Page
@Composable
fun FreightBrokeringPage() {
    val breakpoint = rememberBreakpoint()
    val context = rememberPageContext()

    PageLayout("Freight Brokering") {

        Section(Modifier.classNames("hero", "is-medium", "has-background-light").toAttrs()) {
            Div(Modifier.classNames("container", "is-widescreen").toAttrs()) {
                Div(Modifier.classNames("hero-body").toAttrs()) {
                    H1(Modifier.classNames("title", "is-1").toAttrs()) { Text("FREIGHT BROKERING") }
                    P(Modifier.classNames("subtitle", "is-2").toAttrs()) { Text("LET US TAKE A LOAD OFF YOUR MIND") }
                }
            }
        }

        Section(
            Modifier
                .fontFamily(Constants.FONT_FAMILY2)
                .padding(leftRight = 24.px, top = 24.px, bottom = 48.px)
                .classNames("section")
                .toAttrs()
        ) {
            Row(
                modifier = Modifier
                    .fillMaxWidth(),
                horizontalArrangement = Arrangement.Center
            ) {
                Img(
                    src = "empiregroup-transparent.png",
                    alt = "Empire Group logo",
                    attrs = Modifier
                        .padding(top = 1.cssRem, bottom = 2.cssRem)
                        .height(200.px)
                        .width(autoLength)
                        .toAttrs()
                )
            }
            Div(Modifier.classNames("container", "is-max-desktop").toAttrs()) {
                H1(Modifier.classNames("title", "is-2", "has-text-dark").toAttrs()) { Text("ASSET BASED FLEET") }
                Div(Modifier.classNames("content").toAttrs()) {
                    P() { Text("Braun Equipment has forged a strategic partnership with Empire Group Unlimited, operating under the same ownership, to amplify our freight capabilities. While Braun Equipment specializes in transportation, Empire Group Unlimited serves as our affiliated freight brokerage. This collaboration enables us to adeptly address diverse customer needs that extend beyond our own assets. Whether managing a single load or multiple loads, our network of screened carriers guarantees the prompt and dependable transportation of our customers' freight. Emphasizing a seamless yet distinct relationship, Braun Equipment remains dedicated to providing flexible and reliable logistics solutions through its collaborative effort with Empire Group Unlimited, the dedicated freight brokerage. ") }
                }
            }
        }

        Section(Modifier.fontFamily(Constants.FONT_FAMILY2).classNames("section", "has-background-grey-darker").toAttrs()) {
            Div(Modifier.classNames("container", "is-max-desktop").toAttrs()) {
                H1(
                    Modifier.classNames("title", "is-2", "has-text-light", "has-text-centered").toAttrs()
                ) { Text("Screened Carriers & Specialized Freight") }
                Div(Modifier.classNames("content", "has-text-centered", "has-text-light").toAttrs()) {
                    P() { Text("Empire Group Unlimited works with an array of carriers to facilitate all customer needs. These carriers are monitored and screened ensuring products are handled in a timely and safe manner. We also understand our customers have unique shipping needs, therefore we offer a range of specialized freight services.") }
                }

                Div(
                    Modifier
                        .width(100.percent)
                        .margin(10.px)
                        .classNames("columns")
                        .toAttrs()
                ) {
                    Div(Modifier.classNames("column").toAttrs()) {
                        H3(Modifier.classNames("title", "is-3", "has-text-light", "has-text-centered").toAttrs()) { Text("Services") }
                        Div(Modifier.classNames("content", "is-medium").toAttrs()) {
                            Ul(smallListStyle.toModifier().classNames("is-flex", "is-justify-content-center", "is-flex-direction-column", "has-text-light").toAttrs()) {
                                Li() { Text("Full Truck Load Service (FTL)") }
                                Li() { Text("Oversize Services") }
                                Li() { Text("Flatbed, Step Deck, Van, Refrigerated, Bottom/End Dump, Logs, Chips") }
                                Li() { Text("Pilot Car Services") }
                            }
                        }
                    }

                    Div(Modifier.classNames("column").toAttrs()) {
                        H3(Modifier.classNames("title", "is-3", "has-text-light", "has-text-centered").toAttrs()) { Text("Customer Perks") }
                        Div(Modifier.classNames("content", "is-medium").toAttrs()) {
                            Ul(smallListStyle.toModifier().classNames("is-flex", "is-justify-content-center", "is-flex-direction-column", "has-text-light").toAttrs()) {
                                Li() { Text("Shipments Constantly Monitored") }
                                Li() { Text("Customer Support Plans") }
                                Li() { Text("Dedicated Account Management") }
                                Li() { Text("Unlimited Quick Response Quotes") }
                            }
                        }
                    }
                }
            }
        }

        Section(Modifier.fontFamily(Constants.FONT_FAMILY2).classNames("section", "is-small", "has-background-light").toAttrs()) {
            Div(Modifier.classNames("container", "is-max-desktop").toAttrs()) {
                H1(Modifier.classNames("title", "is-4", "has-text-grey", "has-text-centered").toAttrs()) { Text("Licensed - Bonded - Insured") }
                Div(Modifier.classNames("content", "has-text-grey").toAttrs()) {
                    P() { Text("In addition to specialty license, and bond, Empire Group Unlimited carries additional liability and contingent cargo insurance. Further allowing our customers peace of mind that their valuable products are in the right hands.")}

                    Div(Modifier
                        .width(if (breakpoint < Breakpoint.MD) 100.percent else 500.px)
                        .classNames("columns").toAttrs()) {
                        Div(Modifier.classNames("column").toAttrs()) {
                            Span(Modifier.classNames("subtitle", "has-text-centered", "has-text-grey").toAttrs()) { Text("Broker MC # 2974807") }
                        }

                        Div(Modifier.classNames("column").toAttrs()) {
                            Span(Modifier.classNames("subtitle", "has-text-centered", "has-text-grey").toAttrs()) { Text("Bond # 2965118") }
                        }
                    }
                }

                Div(smallPDFBoxStyle.toModifier().classNames("box", "is-flex", "is-flex-direction-column", "is-justify-content-center",  "mt-6").toAttrs()) {
                    H3(Modifier.classNames("title", "has-text-centered", "has-text-dark").toAttrs()) { Text("Broker Carrier Agreement") }
                    P(Modifier.classNames("subtitle", "has-text-centered", "has-text-dark").toAttrs()) { Text("Empire Broker Carrier Agreement 2019 (PDF)") }

                    onClickButton(
                        modifier = Modifier.classNames("button", "is-info"),
                        onClick = {
                            context.router.navigateTo(
                                "https://img1.wsimg.com/blobby/go/dac963b7-ded5-4fc4-97e3-bcae4469fcc5/downloads/Empire%20Broker%20Carrier%20Agreement%20%202019.pdf?ver=1707250462162",
                                openExternalLinksStrategy = OpenLinkStrategy.IN_NEW_TAB
                            )
                        }
                    ) { Text("DOWNLOAD") }
                }
            }
        }
    }
}